import "./Loader.css"
import React from "react"

const Loader = () => {
    return(
        <div className="loader__div">
            <div className="loader"></div>
        </div>

    )
}

export const LoaderWidget = () => {
    return(
        <div className="loader"></div>
    )
}

export default Loader